<template>
  <div>
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="图书名称">
        <Input
          v-model="searchCondition.name"
          placeholder="请输入图书名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="getList(false)"
        ></Input>
      </FormItem>
      <FormItem label="图书分类">
        <Cascader :data="classifyList" v-model="selectClassify" clearable change-on-select></Cascader>
      </FormItem>
      <FormItem label="作者">
        <Input
          v-model="searchCondition.author"
          placeholder="请输入作者关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="getList(false)"
        ></Input>
      </FormItem>
      <FormItem label="出版社">
        <Input
          v-model="searchCondition.publisher"
          placeholder="请输入出版社关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="getList(false)"
        ></Input>
      </FormItem>
      <FormItem label="出版时间">
        <DatePicker
          type="datetimerange"
          placeholder="开始时间~截止时间"
          ref="publishTime"
          v-model="publishTime"
          @on-change="onPublishTimeChange"
          style="width: 300px"
        ></DatePicker>
      </FormItem>
      <FormItem label="入库人">
        <Input
          v-model="searchCondition.creator"
          placeholder="请输入入库人关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="getList(false)"
        ></Input>
      </FormItem>
      <FormItem label="入库时间">
        <DatePicker
          ref="createTime"
          type="datetimerange"
          placeholder="开始时间~截止时间"
          v-model="createTime"
          @on-change="onCreateTimeChange"
          style="width: 300px"
        ></DatePicker>
      </FormItem>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="getList(false)">搜索</Button>
          <Button icon="md-undo" @click="getList(true)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button type="primary" :to="{name:'BookEdit'}">新增图书</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/books"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" :to="{name: 'BookEdit',query:{id:row.id}}">编辑-</Button>
          <Button type="text" size="small" @click="setStatus(row.id,1)" v-if="row.status!=1">上架-</Button>
          <Button type="text" size="small" @click="setStatus(row.id,2,row.course_count)" v-if="row.status==1">下架-</Button>
          <Button type="text" size="small" @click="deleteBook(row.id)" :disabled="row.status==1">删除</Button>
        </template>
        <template slot="footer-left">
          <Button
            class="btn-margin-right"
            type="text"
            :disabled="selectList.length == 0"
            @click="batchDelete"
          >删除</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>

<script>
import { BookStatus } from "@/utils/enums";
export default {
  name: "BookManage",
  data() {
    return {
      searchCondition: {
        name: "",
        book_classify_id: "",
        author: "",
        publisher: "",
        publish_start_at: "",
        publish_end_at: "",
        creator: "",
        start_at: "",
        end_at: ""
      },
      classifyList: [],
      selectClassify: [],
      publishTime: [],
      createTime: [],
      selectList: [],
      columns: [
        {
          title: "图书名称",
          key: "name",
          minWidth: 200
        },
        {
          title: "所属分类",
          key: "book_classify",
          width: 120,
          align: "center"
        },
        {
          title: "作者",
          key: "author",
          width: 100,
          align: "center"
        },
        {
          title: "价格",
          key: "price_yuan",
          width: 100,
          align: "center"
        },
        {
          title: "库存",
          key: "stock",
          width: 100,
          align: "center"
        },{
          title: "是否隐藏",
          key: "hidden",
          width: 100,
          align: "center"
        },
        {
          title: "出版社",
          key: "publisher",
          width: 100,
          align: "center"
        },
        {
          title: "出版时间",
          key: "publish_time_str",
          width: 160,
          align: "center"
        },
        {
          title: "状态",
          key: "statusName",
          width: 120,
          align: "center"
        },
        {
          title: "入库人",
          key: "creator",
          width: 120,
          align: "center"
        },
        {
          title: "入库时间",
          key: "created_at_str",
          width: 160,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          width: 240,
          align: "center",
          fixed: "right"
        }
      ]
    };
  },
  async created() {
    await this.getClassify();
  },
  methods: {
    onPublishTimeChange(range) {
      this.searchCondition.publish_start_at = range[0];
      this.searchCondition.publish_end_at = range[1];
    },
    onCreateTimeChange(range) {
      this.searchCondition.publish_start_at = range[0];
      this.searchCondition.publish_end_at = range[1];
    },
    async getClassify() {
      let list = await this.$http.get("/api/course/classify");
      this.classifyList = list;
      // let classifyList = [];
      // list.forEach(c => {
      //   let classify = { value: c.id, label: c.name, children: [] };
      //   if (c.children) {
      //     c.children.forEach(child => {
      //       classify.children.push({ value: child.id, label: child.name });
      //     });
      //   } else {
      //     return;
      //   }
      //   classifyList.push(classify);
      // });
      // this.classifyList = classifyList;
    },
    getList(reset) {
      if (reset) {
        this.searchCondition.name = "";
        this.searchCondition.book_classify_id = "";
        this.searchCondition.author = "";
        this.searchCondition.publisher = "";
        this.searchCondition.publish_start_at = "";
        this.searchCondition.publish_end_at = "";
        this.searchCondition.creator = "";
        this.searchCondition.start_at = "";
        this.searchCondition.end_at = "";
        this.$refs.publishTime.handleClear();
        this.$refs.createTime.handleClear();
        this.selectClassify = [];
      } else {
        if (this.publishTime.length > 0) {
          this.searchCondition.publish_start_at = this.publishTime[0];
          this.searchCondition.publish_end_at = this.publishTime[1];
        } else {
          this.searchCondition.publish_start_at = "";
          this.searchCondition.publish_end_at = "";
        }
        if (this.createTime.length > 0) {
          this.searchCondition.start_at = this.createTime[0];
          this.searchCondition.end_at = this.createTime[1];
        } else {
          this.searchCondition.start_at = "";
          this.searchCondition.end_at = "";
        }
        if (this.selectClassify.length > 0) {
          this.searchCondition.book_classify_id = this.selectClassify[
            this.selectClassify.length - 1
          ];
        } else {
          this.searchCondition.book_classify_id = "";
        }
      }
      this.$refs.grid.searchRefresh();
    },
    rowsFormatter(rows) {
      rows.forEach(row => {
        row.publish_time_str = new Date(row.publish_time * 1000).format(
          "yyyy-MM-dd hh:mm:ss"
        );
        row.created_at_str = new Date(row.created_at * 1000).format(
          "yyyy-MM-dd hh:mm:ss"
        );
        row.statusName = BookStatus.getValue(row.status);
        row.price_yuan = row.price / 100;
        row.hidden = row.is_hidden ? '是' : '否';
      });
    },
    onSelectionChange(list) {
      this.selectList = list;
    },
    async deleteBook(id) {
      await this.$promiseConfirm("确定要删除吗？");
      await this.$http.delete("/api/books/" + id);
      this.$refs.grid.refresh();
    },
    async batchDelete() {
      let ids = [];
      for (let i = 0; i < this.selectList.length; i++) {
        let item = this.selectList[i];
        if (item.status == 1) {
          this.$Message.warning('已上架的图书不能删除');
          return;
        }
        ids.push(item.id);
      }
      let id = ids.join(",");
      await this.deleteBook(id);
      this.selectList = [];
    },
    async setStatus(id, status, course_count = 0) {
      if (status == 2) {
        if( course_count  > 0) {
          await this.$Message.warning("该图书已应用于课程赠送，请先取消赠送再进行下架操作");
          return
        }else {
          await this.$promiseConfirm("确定下架吗？");
        }
      }
      await this.$http.put("/api/books/shelf/" + id);
      this.$refs.grid.refresh();
      this.selectList = [];
      if (status == 1) {
        this.$Message.success("上架成功");
      } else {
        this.$Message.success("下架成功");
      }
    }
  }
};
</script>
